// extracted by mini-css-extract-plugin
export var button = "_2w-1";
export var featuredLink = "_2w-4";
export var spinner = "_2w-2";
export var spinnerContainer = "_2w-3";
export var text = "_2w-0";